/* Progressive occasion finder. */
(function () {
  'use strict';
  if (window.__alpStudio) return;
  window.__alpStudio = true;
  var mounts = new Map();
  function mount(root) {
    if (mounts.has(root)) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var cleanups = [];
    root.querySelectorAll('[data-studio-finder]').forEach(function (finder) {
      var choices = Array.from(finder.querySelectorAll('[data-studio-choice]'));
      var panels = Array.from(finder.querySelectorAll('[data-studio-panel]'));
      function select(button) {
        var id = button.dataset.studioChoice;
        choices.forEach(function (choice) { choice.setAttribute('aria-pressed', String(choice === button)); });
        panels.forEach(function (panel) {
          var active = panel.dataset.studioPanel === id;
          var changed = panel.hidden && active;
          panel.hidden = !active;
          if (changed && !reduce.matches && panel.animate) panel.animate([{ opacity: .5, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 260, easing: 'ease-out' });
        });
      }
      function click(event) { var button = event.target.closest('[data-studio-choice]'); if (button && finder.contains(button)) select(button); }
      function keys(event) {
        var index = choices.indexOf(event.target);
        if (index < 0 || !['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        var next = event.key === 'Home' ? 0 : event.key === 'End' ? choices.length - 1 : (index + (event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1) + choices.length) % choices.length;
        choices[next].focus({ preventScroll: true }); select(choices[next]);
      }
      finder.addEventListener('click', click); finder.addEventListener('keydown', keys);
      cleanups.push(function () { finder.removeEventListener('click', click); finder.removeEventListener('keydown', keys); });
    });

    mounts.set(root, function () { cleanups.forEach(function (cleanup) { cleanup(); }); mounts.delete(root); });
  }
  function boot(scope) {
    if (scope.matches && scope.matches('.alp-studio')) mount(scope);
    scope.querySelectorAll('.alp-studio').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { mounts.forEach(function (dispose, root) { if (event.target.contains(root)) dispose(); }); });
})();
